<template>
  <div class="penalty-table">
    <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        border
        stripe
    >
      <el-table-column
          type="index"
          label="序号"
          width="60"
          align="center"
      ></el-table-column>

      <el-table-column
          prop="type"
          show-overflow-tooltip
          label="处罚类型"
          align="center"
      />
      <el-table-column prop="levelDesc" label="处罚等级" align="center">
        <template #default="{ row }">
          <div class="level-tag">
            <span
                class="level-dot"
                :style="{ backgroundColor: getLevelColor(row.levelcode) }"
            ></span>
            {{ row.levelDesc }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
          prop="stationName"
          show-overflow-tooltip
          label="企业"
          align="center"
      >
        <template #default="{ row }">
          <span>{{ row.company.name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="stationTypeName" label="类型" align="center">
        <template #default="{ row }">
          <span>{{ row.stationTypeName }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="description"
          show-overflow-tooltip
          label="处罚描述"
          align="center"
      />
      <el-table-column prop="gmtCreated" label="处罚日期" align="center"/>
      <el-table-column label="操作" width="120" align="center">
        <template #default="{ row }">
          <el-button type="text" size="small" @click="showDetail(row)"
          >查看详情
          </el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="resourcePage">
      <el-pagination
          background
          @current-change="currentChange"
          layout="prev, pager, next"
          :total="total"
          :current-page="current"
      >
      </el-pagination>
    </div>
    <!-- 详情弹窗 -->
    <el-dialog
        title="安全处理详情"
        :visible.sync="dialogVisible"
        destroy-on-close
        :width="dialogWidth"
        custom-class="penalty-dialog"
    >
      <div class="detail-content">
        <!-- 站点信息 -->
        <div class="detail-section">
          <div class="section-title">
            <span></span>
            <span>企业</span>
          </div>
          <div class="section-content">
            <div class="info-row info-title">
              <span class="info-value">{{ dislogInfo.company?.name }}</span
              >
              <el-divider direction="vertical"/>
              <span class="info-value">{{
                  dislogInfo?.stationTypeName
                }}</span>
            </div>
            <div class="info-row info-content">
              <div>
                <el-avatar
                    size="small"
                    src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
                />
                <span class="info-value info-user">{{
                    dislogInfo.company?.linkman
                  }}</span>
                <span class="info-value info-tel">{{
                    dislogInfo.company?.cellPhone
                  }}</span>
              </div>
              <div>{{ dislogInfo.company?.gmtCreated }}</div>
            </div>
          </div>
        </div>

        <!-- 处罚类型 -->
        <div class="detail-section">
          <div class="section-title">
            <span></span>
            <span>处罚类型</span>
          </div>
          <div class="section-content">
            <div class="info-row info-title">
              <span class="info-value">{{ dislogInfo?.type }}</span
              ><span
                class="info-value info-dot"
                :style="{
                  backgroundColor: getLevelbackColor(dislogInfo?.levelcode),
                  color: getLevelColor(dislogInfo?.levelcode),
                }"
            >{{ getLveleType(dislogInfo?.levelcode) }}</span
            >
            </div>
            <div class="info-row">
              <span class="info-value info-PenaltyResult">{{
                  dislogInfo?.description
                }}</span>
            </div>
          </div>
        </div>
        <!-- 处罚单位 -->
        <div class="detail-section">
          <div class="section-title">
            <span></span>
            <span>处罚单位</span>
          </div>
          <p class="detail-unit">{{ dislogInfo.punishmentUnit }}</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getPunishmentList} from '@/API/Punishment/Punishment';
import {getTimeRange} from '@/util/dateRange';

export default {
  name: 'PenaltyTable',
  props: {
    timeSpan: {
      type: String,
      default: '0',
    },
  },
  watch: {
    timeSpan: {
      handler: function (val) {
        this.current = 1;
        this.getTableData();
      },
    },
  },
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      dislogInfo: {},
      current: 1,
      total: 10,
      loading: false,
      windowWidth: window.innerWidth, // 存储当前窗口宽度
      dialogWidth: '480px', // 弹窗基础宽度（大屏默认值）
    };
  },
  mounted() {
    this.getTableData();
    // 初始化弹窗宽度
    this.setDialogWidthByScreen();
    // 监听窗口大小变化，实时更新弹窗宽度
    window.addEventListener('resize', this.setDialogWidthByScreen);
  },
  // 组件销毁时移除监听，避免内存泄漏
  beforeDestroy() {
    window.removeEventListener('resize', this.setDialogWidthByScreen);
  },
  methods: {
    // 新增：监听窗口宽度，动态设置弹窗宽度
    setDialogWidthByScreen() {
      this.windowWidth = window.innerWidth;
      // 768px及以下为移动端，弹窗宽度设为90%；以上为大屏，用默认百分比
      if (this.windowWidth <= 768) {
        this.dialogWidth = '90%'; // 移动端占满屏幕，操作更友好
      } else {
        this.dialogWidth = '480px'; // 大屏保持原有35%宽度
      }
    },
    getLevelbackColor(level) {
      const colors = {
        danger: '#FFEEEE',
        warning: '#FEEDD7',
        info: '#E9E9E9',
      };
      return colors[level] || '#FF5151';
    },
    getLevelColor(level) {
      const colors = {
        danger: '#FF5151',
        warning: '#F08400',
        info: '#788295',
      };
      return colors[level] || '#FF5151';
    },
    getLveleType(level) {
      const LveleType = {
        danger: '高等级处罚',
        warning: '中等级处罚',
        info: '普通处罚',
      };
      return LveleType[level] || '普通处罚';
    },
    getTableData() {
      this.loading = true;
      let parmrs = {
        level: '',
        beginDate: getTimeRange(this.timeSpan).startTime,
        endDate: getTimeRange(this.timeSpan).endTime,
        pageNum: this.current,
        pageSize: 10,
      };

      getPunishmentList(parmrs)
          .then((res) => {
            if (res.code === 200) {
              this.total = res.data.total;
              let list = res.data.records;
              list.forEach((item) => {
                item.stationTypeName = formatBusinessType(item.company.businessType);

                function formatBusinessType(type) {
                  const typeMap = {
                    recycleStation: '回收网点',
                    transferStation: '中转站',
                    sortingCenter: '分拣中心',
                    wasteEnterprise: '利废企业',
                    dismantlingCenter: '二手交易市场',
                    industrialPark: '产业园区/集散市场',
                    other: '其他',
                  };
                  return typeMap[type] || type;
                }

                switch (item.levelDesc) {
                  case '高':
                    return (item.levelcode = 'danger');
                    break;
                  case '中':
                    return (item.levelcode = 'warning');
                    break;
                  case '低':
                    return (item.levelcode = 'info');
                    break;
                }
              });
              this.tableData = list;
            }
          })
          .finally(() => {
            this.loading = false;
          });
    },
    showDetail(row) {
      this.dislogInfo = row;
      this.dialogVisible = true;
    },
    currentChange(current) {
      this.current = current;
      this.getTableData();
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 768px) {
  /deep/ .el-dialog__header {
    font-size: 14px !important;
    height: 50px !important;
    line-height: 50px !important;

    .el-dialog__title {
      font-weight: bold !important;
      font-size: 14px !important;
    }
  }

  /deep/ .el-dialog__body {
    .detail-content {
      height: 300px !important;

      .detail-section {
        .section-title {
          span:first-child {
            height: 15px !important;
            width: 3px !important;
          }
        }
        .section-content {
          padding: 10px 5px !important;
          .info-title {
            font-size: 14px !important;
            line-height: unset !important;
            .info-dot{
              height: 16px !important;
              line-height: 16px !important;
              font-size: 12px !important;
            }
          }
          .info-content {
            height: 50px !important;
            font-size: 14px !important;
          }
          .info-PenaltyResult{
            line-height: unset !important;
            font-size: 14px !important;
          }
        }
        .detail-unit{
          line-height: unset !important;
          font-size: 14px !important;
        }
      }
    }
  }
}


.penalty-table {
  padding: 20px;

  /deep/ .el-dialog {
    border-radius: 8px;
  }

  /deep/ .el-dialog__title {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: rgb(34, 34, 34);
  }

  /deep/ .el-dialog__header {
    border-bottom: 1px solid rgb(238, 238, 238);
    padding: 10px 20px 10px;
  }

  /deep/ .el-dialog__body {
    padding: 20px !important;
  }
}

.level-tag {
  display: flex;
  align-items: center;
  justify-content: center;
}

.level-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 8px;
}

.detail-content {
  height: 400px;
  overflow-y: auto;
  padding: 0 10px;
}

.detail-section {
  margin-bottom: 20px;
  border-radius: 4px;

  .detail-unit {
    color: rgb(34, 34, 34);
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    padding: 0 15px;
  }
}

.section-title {
  padding: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;

  span:first-child {
    display: inline-block;
    height: 14px;
    width: 3px;
    background-color: #1da1f2;
    margin-right: 5px;
  }
}

.section-content {
  padding: 15px;
  border-radius: 4px;
  background: rgb(249, 249, 249);
}

.section-content + .section-content {
  border-top: 1px dashed #ebeef5;
}

.info-row {
  margin-bottom: 10px;
  display: flex;
}

.info-title {
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  color: rgb(34, 34, 34);
  display: flex;
  align-items: center;

  /deep/ .el-divider--vertical {
    width: 2px;
    background-color: rgb(120, 130, 149);
  }
}

.info-dot {
  border-radius: 4px;
  padding: 2px 6px 2px 6px;
  height: 24px;
  line-height: 24px;
  margin-left: 15px;
  font-size: 12px;
  font-weight: 400;
  color: rgb(255, 81, 81);
}

.info-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: rgb(120, 130, 149);

  div:first-child {
    display: flex;
    align-items: center;

    .info-user {
      margin: 0 10px 0 5px;
    }
  }
}

.info-PenaltyResult {
  color: rgb(77, 81, 90);
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-label {
  width: 80px;
  color: #909399;
}

.resourcePage {
  display: flex;
  justify-content: end;
  padding: 10px 10px 0 10px;
}
</style>
